import { CloseEditorIfOpenedEvent } from '../BuilderController';
import { BUILDER_BLOCK_SKILLS_SIDEBAR_CLOSE, } from './PreparedBlocksSegmentEvents';
import onboarding from './resources/onboarding.json';
import lgpd from './resources/lgpd.json';
import inactivity from './resources/inactivity.json';
import optinout from './resources/optinout.json';
import anythingElse from './resources/anythingElse.json';
import finalization from './resources/finalization.json';
import agentRegister from './resources/agentRegister.json';
import collectData from './resources/collectData.json';
import csat from './resources/csat.json';
import humanAttendance from './resources/humanAttendance.json';
import leadsQualification from './resources/leadsQualification.json';
import personalData from './resources/personalData.json';
import waterfallErrors from './resources/waterfallErrors.json';
import faq from './resources/faq.json';
import abandonesCart from './resources/abandonesCart.json';
import catalogAndCart from './resources/catalogAndCart.json';
import financialMenu from './resources/financialMenu.json';
import onboardingImage from './resources/images/onboarding.png';
import lgpdImage from './resources/images/lgpd.png';
import inactivityImage from './resources/images/inactivity.png';
import optinoutImage from './resources/images/optinout.png';
import anythingElseImage from './resources/images/anythingElse.png';
import finalizationImage from './resources/images/finalization.png';
import agentRegisterImage from './resources/images/agentRegister.png';
import collectDataImage from './resources/images/collectData.png';
import csatImage from './resources/images/csat.png';
import humanAttendanceImage from './resources/images/humanAttendance.png';
import leadsQualificationImage from './resources/images/leadsQualification.png';
import personalDataImage from './resources/images/personalData.png';
import waterfallErrorsImage from './resources/images/waterfallErrors.png';
import faqImage from './resources/images/faq.png';
import abandonesCartImage from './resources/images/abandonesCart.png';
import catalogAndCartImage from './resources/images/catalogAndCart.png';
import financialMenuImage from './resources/images/financialMenu.png';
import './PreparedBlocks.scss';
export class PreparedBlocksController {
    static $inject = ['close', 'clipboard', '$rootScope', '$translate', '$timeout', 'SegmentService', 'BlipToastService', 'duplicateUndoRedoStateClipboard'];
    constructor(close, clipboard, $rootScope, $translate, $timeout, SegmentService, BlipToastService, duplicateUndoRedoStateClipboard) {
        this.close = close;
        this.clipboard = clipboard;
        this.$rootScope = $rootScope;
        this.$translate = $translate;
        this.$timeout = $timeout;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.duplicateUndoRedoStateClipboard = duplicateUndoRedoStateClipboard;
        this.preparedBlocksList = [];
        this.preparedBlocksListOriginal = [];
        this.onInputChangeCustom = async (event) => {
            this.selectedTag = '';
            const value = event.detail.value;
            await this.filteredBlocks(value);
        };
        this.init();
    }
    async init() {
        await this.initializeBlocks();
        this.initializaTags();
    }
    async initializeBlocks() {
        const resources = {
            onboarding,
            lgpd,
            inactivity,
            optinout,
            anythingElse,
            finalization,
            agentRegister,
            collectData,
            csat,
            humanAttendance,
            leadsQualification,
            personalData,
            waterfallErrors,
            faq,
            abandonesCart,
            catalogAndCart,
            financialMenu,
        };
        const resourceImages = {
            onboardingImage,
            lgpdImage,
            inactivityImage,
            optinoutImage,
            anythingElseImage,
            finalizationImage,
            agentRegisterImage,
            collectDataImage,
            csatImage,
            humanAttendanceImage,
            leadsQualificationImage,
            personalDataImage,
            waterfallErrorsImage,
            faqImage,
            abandonesCartImage,
            catalogAndCartImage,
            financialMenuImage,
        };
        const blocksIds = Object.keys(resources);
        for (const id of blocksIds) {
            const trlPrefix = `preparedBlocks.options.${id}`;
            const image = resourceImages[`${id}Image`];
            const finalTag = `${await this.$translate(`${trlPrefix}.categorie`)} • ${await this.$translate(`${trlPrefix}.tag`)}`;
            this.preparedBlocksList.push({
                title: await this.$translate(`${trlPrefix}.title`),
                description: await this.$translate(`${trlPrefix}.description`),
                categorie: await this.$translate(`${trlPrefix}.categorie`),
                tag: await this.$translate(`${trlPrefix}.tag`),
                finalTag: finalTag,
                image,
                resource: resources[id],
            });
            this.preparedBlocksListOriginal = [...this.preparedBlocksList];
        }
    }
    initializaTags() {
        const categories = [
            ...new Set(this.preparedBlocksList.map(b => b.categorie)),
        ];
        const onlyTags = [...new Set(this.preparedBlocksList.map(b => b.tag))];
        this.availableCategories = [...categories];
        this.availableTags = [...onlyTags];
    }
    async filterByTag(tag) {
        this.selectedTag = tag;
        this.filteredBlocks(tag);
    }
    clearTagFilter(event) {
        event.stopPropagation();
        this.selectedTag = null;
        this.preparedBlocksList = this.preparedBlocksListOriginal;
    }
    async filterByText(text) {
        this.filteredBlocks(text);
    }
    async filteredBlocks(dataToFind) {
        if (dataToFind) {
            const blocksFiltered = this.preparedBlocksListOriginal.filter(everyBlock => {
                const dataInlcudesOnTitle = everyBlock.title
                    .toLowerCase()
                    .includes(dataToFind.toLowerCase());
                const dataInlcudesOnDescription = everyBlock.description
                    .toLowerCase()
                    .includes(dataToFind.toLowerCase());
                const dataInlcudesOnBy = everyBlock.categorie
                    .toLowerCase()
                    .includes(dataToFind.toLowerCase());
                const blockIncludesDataToFind = everyBlock.tag == dataToFind ||
                    dataInlcudesOnTitle ||
                    dataInlcudesOnBy ||
                    dataInlcudesOnDescription;
                return blockIncludesDataToFind;
            });
            this.preparedBlocksList = blocksFiltered;
        }
        else {
            this.preparedBlocksList = this.preparedBlocksListOriginal;
        }
    }
    async closeModal() {
        try {
            this.$rootScope.$broadcast(CloseEditorIfOpenedEvent);
            this.SegmentService.createOrganizationTrack(BUILDER_BLOCK_SKILLS_SIDEBAR_CLOSE);
            await this.close();
        }
        catch (e) {
            console.error(e);
        }
    }
    async showBlockDetails(block) {
        this.selectedBlock = block;
    }
    async pasteBlockOnFlow(data) {
        try {
            await this.duplicateUndoRedoStateClipboard(JSON.stringify(data));
            this.$timeout(async () => {
                this.BlipToastService.show('success', {
                    title: await this.$translate('preparedBlocks.pasteFlow.sucess.title'),
                    msg: await this.$translate('preparedBlocks.pasteFlow.sucess.message'),
                    duration: 3000,
                });
            }, 600);
            this.closeModal();
        }
        catch (e) {
            this.$timeout(async () => {
                this.BlipToastService.show('danger', {
                    title: await this.$translate('preparedBlocks.pasteFlow.fail.title'),
                    msg: await this.$translate('preparedBlocks.pasteFlow.fail.message'),
                    duration: 3000,
                });
            }, 600);
        }
    }
}
PreparedBlocksController.$inject = ['close', 'clipboard', '$rootScope', '$translate', '$timeout', 'SegmentService', 'BlipToastService', 'duplicateUndoRedoStateClipboard'];
